<template>
  <div class="modal-frame modal-large" :class="{active:isOpen}" data-modal="attach-popup">
    <div class="modal-frame-content">
      <button @click="$emit('close')" class="btn-close" rel="button_close" type="button" data-modal-close>
        <svg class="svg-cross">
          <use href="/img/sprite.svg#svg-cross"></use>
        </svg>
      </button>
      <div class="modal-frame-header">
        <div class="h3">Вложения</div>
      </div>
      <div class="modal-frame-body scroll-y">
        <div class="attach-list">
          <!--single item-->
          <template v-for="item in items" :key="item.id">
          <div v-if="hasPhotos(item)" class="attach-item">
            <div class="attach-item-title flex">
              <div class="muted-13">Артикул:</div>
              <div class="font-15">{{ item.article_old }}</div>
            </div>
            <div class="attach-group">
              <img v-for="photo in item.photo" :key="photo" :src="photo" width="150" height="150" loading="lazy" alt="img">
            </div>
          </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {bool} from "yup";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: bool,
      default: () => false,
    },
    mode: ''
  },
  data: () => ({

  }),
  created() {

  },
  computed: {

  },
  methods: {
    hasPhotos(item) {
      return Array.isArray(item?.photo) && item.photo.length > 0;
    },
  }
}
</script>
